module.exports = __webpack_public_path__ + "static/humana-logo-fr-2d38f78c339de6f455911bb8fd42836b.jpeg";